export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[var(--walnut-deep)] text-[var(--stone)] border-t border-[var(--border-dark)]">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-16 grid sm:grid-cols-3 gap-12">
        <div>
          <div className="flex flex-col leading-none">
            <span className="font-serif text-[10px] uppercase tracking-[0.42em] text-[var(--muted-dark)]">
              The House of
            </span>
            <span className="font-serif text-2xl tracking-[0.24em] text-[var(--ivory)] mt-1 font-light">
              BORSALUX
            </span>
          </div>
          <p className="mt-6 font-sans text-sm text-[var(--stone)]/70 max-w-xs leading-relaxed">
            An intentional place for the things people carry.
          </p>
          <p className="mt-4 font-sans text-xs tracking-[0.32em] uppercase text-[var(--gold-light)]/70">
            Set It Down
          </p>
        </div>

        <div>
          <p className="font-sans text-[10px] uppercase tracking-[0.32em] text-[var(--muted-dark)] mb-4">
            Correspondence
          </p>
          <a
            href="mailto:telesa@borsalux.com"
            className="font-serif text-[var(--ivory)] text-lg hover:text-[var(--gold-light)] transition-colors"
          >
            telesa@borsalux.com
          </a>
          <p className="mt-3 font-sans text-sm text-[var(--stone)]/70">
            (949) 444-3548
          </p>
        </div>

        <div>
          <p className="font-sans text-[10px] uppercase tracking-[0.32em] text-[var(--muted-dark)] mb-4">
            Inquiry
          </p>
          <ul className="space-y-1.5 font-sans text-sm text-[var(--stone)]/80">
            <li>— Commercial</li>
            <li>— Licensing & Strategic Partnerships</li>
            <li>— Design & Architectural Collaboration</li>
            <li>— Pilot Opportunities</li>
            <li>— Media & Press</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--border-dark)]">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row gap-3 justify-between items-center font-sans text-xs text-[var(--muted-dark)]">
          <span>© {year} The House of BorsaLux · The Abike Collection · Patent Pending</span>
          <span className="tracking-[0.32em] uppercase text-[10px]">
            Everything Deserves A Place
          </span>
        </div>
      </div>
    </footer>
  );
};
